/** 墨西哥注册手机号：只留本国 10 位数字。粘贴 +52 / 52 前缀时先去掉区号再截断。 */
export const MX_PHONE_MAX_DIGITS = 10;

export function normalizeMxRegisterPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  const local = digits.length >= 12 && digits.startsWith('52') ? digits.slice(2) : digits;
  return local.slice(0, MX_PHONE_MAX_DIGITS);
}

export function isMxRegisterPhoneComplete(digits: string): boolean {
  return digits.length === MX_PHONE_MAX_DIGITS;
}
